import ViewSharedUtil from "../ViewSharedUtil.js";

class ViewLocalStateStorage {

  constructor(keyName) {
    this.keyName = keyName;
  }

  saveStateMutation(processedState, viewManager, viewType) {
    const localStateKey = viewManager.renderState.selectedView.viewType;
    const oldLocalState = ViewSharedUtil.getFromLocalStorageForKey(viewManager.renderState.selectedView.viewType, {});
    const localState = processedState[this.keyName];
    ViewSharedUtil.saveToLocalStorageForKey(localStateKey, { ...oldLocalState, [viewType]: localState })
  }

}

export default ViewLocalStateStorage;